<div class="main-box">
  <p-toast></p-toast>
  <div [formGroup]="templateForm">
    <p-button label="Submit" (onClick)="sendForm()" [disabled]="sendingForm"></p-button>
    <table>
      <tr>
        <td>
          Template name*
        </td>
        <td>
          <input pInputText placeholder="Name" type="text" formControlName="name">
        </td>
      </tr>
      <tr>
        <td>
          Content*
        </td>
        <td>
          <textarea class="raw-editor" formControlName="body"></textarea>
        </td>
      </tr>
    </table>
  </div>
</div>